import {Component, input, OnDestroy, OnInit} from '@angular/core';
import {IYii} from '../../globals';
import {FormPropertiesTab} from './properties/form-properties-tab';
import {EditFieldsTabComponent} from './fields/edit-fields-tab';
import {AssignmentsTab} from './assignments/assignments-tab';
import {AssignmentService} from './services/AssignmentService';
import {FIELD_TYPE_CALCULATED, FormService} from './services/FormService';
import {SystemService} from './services/SystemService';
import {CalculationService} from './services/CalculationService';
import {AppDialogService} from './services/AppDialogService';
import {Tab, TabList, TabPanel, TabPanels, Tabs} from 'primeng/tabs';
import {Router, RouterLink} from '@angular/router';
import {ProgressBar} from 'primeng/progressbar';
import {Toast} from 'primeng/toast';
import {DisplayFieldsService} from './services/display-fields.service';
import {Button} from 'primeng/button';
import {MessageService} from 'primeng/api';
import {ApproversService} from './services/ApproversService';
import {PositionsService} from './services/PositionsService';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {first} from 'rxjs';
import {ApiService} from './services/ApiService';
import {HttpErrorResponse} from '@angular/common/http';
import {TranslocoPipe, TranslocoService} from '@ngneat/transloco';

declare var Yii: IYii;

@Component({
  selector: 'forms-builder-edit',
  templateUrl: './edit.component.html',
  imports: [
    FormPropertiesTab,
    EditFieldsTabComponent,
    AssignmentsTab,
    Tabs,
    TabList,
    Tab,
    TabPanels,
    TabPanel,
    RouterLink,
    ProgressBar,
    Toast,
    Button,
    TranslocoPipe,
  ],
  styleUrls: ['./edit.component.scss'],
})
export class FormsBuilderEditComponent implements OnInit, OnDestroy {
  public formId = input.required<number>();

  public Yii = Yii;

  constructor(
    public api: ApiService,
    public asvc: AssignmentService,
    public fsvc: FormService,
    public csvc: CalculationService,
    public sysvc: SystemService,
    private dialogs: AppDialogService,
    private displayFieldsService: DisplayFieldsService,
    private toast: MessageService,
    private approvers: ApproversService,
    private positions: PositionsService,
    private router: Router,
    private t: TranslocoService,
  ) {
  }

  loadForm() {

    this.fsvc.form_json.assignedChains = [];

    if (this.formId()) {
      this.fsvc.formLoading.set(true);

      this.api.LoadForm(this.formId())
        .pipe(first())
        .subscribe({
          next: (data:{data:any;status:boolean,message:string}) => {
            if (data && data.data && data.data.form_json_content) {

              this.fsvc.formLoading.set(false);

              this.fsvc.form_json = JSON.parse(data.data.form_json_content);

              this.fsvc.form = this.fsvc.form_json;

              this.fsvc.form_json.form_id = this.formId();

              this.fsvc.form_json.attachPdfToEmail = parseInt(data.data.attach_pdf_to_email) === 1;
              this.fsvc.form_json.includeInSignWizard = parseInt(data.data.include_in_sign_wizard) === 1;

              if (this.fsvc.form_json.isHTMLForm) {
              } else {
                const typeDropDown = "dropdown";
                this.fsvc.form_json.form_fields.forEach((field: any, key: any) => {
                  this.fsvc.form_json.form_fields[key]['accordionContentStatus'] = false;

                  if (field.field_type === typeDropDown
                    && field.field_value && field.field_options
                    && field.field_options[parseInt(field.field_value.option_id)]
                  ) {
                    field.field_value = field.field_options[parseInt(field.field_value.option_id)]
                  }
                });
              }
              const assignedChains = this.fsvc.form_json.assignedChains;

              this.fsvc.form_json.assignedChains = [];
              if (assignedChains) {
                assignedChains.forEach((assignedChain: any) => {
                  this.sysvc.chains.forEach((chainModel) => {
                    if (Number(chainModel.chain_id) === Number(assignedChain.chain_id)) {
                      this.fsvc.form_json.assignedChains.push(chainModel);
                      this.asvc.AddAssignment(chainModel.chain_id, 0)
                    }
                  });
                });
              }
            } else {
              let ref: DynamicDialogRef;
              if (typeof data != "undefined" && data && typeof data.message != "undefined" && data.message) {
                ref = this.dialogs.Alert("Error", data.message);
              } else {
                ref = this.dialogs.Alert("Error", "Sorry, an internal error has occurred, your approvers will not be loaded.");
              }
              ref.onClose.pipe(first()).subscribe(() => {
                this.router.navigateByUrl('/forms/builder/index').then();
              })
              return
            }

            this.fsvc.fieldService.SetFields(this.fsvc.form_json.form_fields);
            this.fsvc.calculation.SyncFields(this.fsvc.form_json.form_fields);
            this.fsvc.duplicate.SetFields(this.fsvc.form_json.form_fields)
          },
          error: (e:HttpErrorResponse) => {
            this.fsvc.formLoading.set(false);
            const ref = this.dialogs.Alert("Server Error", e.message);
            ref.onClose.pipe(first()).subscribe(() => {
              this.router.navigateByUrl('/forms/builder/index').then();
            })
            return
          }
        })
    } else {
      this.fsvc.formLoading.set(false);
    }
  };

  submit() {

    let validateSuccess = true;
    let validateErrorMessage = '';

    if (this.fsvc.form_json.form_name.trim() === '') {
      validateErrorMessage = Yii.t("app_js", 'Form Title should not be empty!');
      validateSuccess = false;
    }

    if (
      validateSuccess && (this.fsvc.form_json.form_fields === null || this.fsvc.form_json.form_fields.length === 0)
      &&
      !this.fsvc.form_json.isHTMLForm
    ) {
      validateErrorMessage = Yii.t("app_js",
        'No fields added yet, please add fields to the form before saving.'
      );
      validateSuccess = false;
    }

    //Checking for cyclic links for calculated fields
    if (validateSuccess) {
      this.fsvc.form_json.form_fields.forEach(
        (fieldObj: any) => {
          if (typeof fieldObj == "undefined"
            || fieldObj.field_type !== FIELD_TYPE_CALCULATED
            || fieldObj.selected_fields.length === 0
          ) {
            return true;
          }

          if (!validateSuccess) {
            return true;
          }

          if (fieldObj.operation === 'open_formula') {
            this.csvc.validateOpenFormula(this.fsvc.form_json, fieldObj);
          }

          if (typeof fieldObj.showError != "undefined" && fieldObj.showError.trim() !== '') {
            validateSuccess = false;
            validateErrorMessage = Yii.t("app_js", 'The ' + fieldObj.field_title + ' contains error.');
            validateErrorMessage += Yii.t("app_js", fieldObj.showError);
            return true;
          }

          fieldObj.selected_fields.forEach((fieldId: any) => {
            if (typeof fieldId == "undefined") {
              return true;
            }

            this.fsvc.form_json.form_fields.forEach((fieldObj2: any) => {
              if (typeof fieldObj2 != "undefined"
                && fieldObj2.field_type === FIELD_TYPE_CALCULATED
                && parseInt(fieldObj2.field_id) === parseInt(fieldId)
                && fieldObj2.selected_fields.length > 0
                && fieldObj2.selected_fields.includes(fieldObj.field_id)
              ) {
                validateSuccess = false;
                validateErrorMessage = Yii.t("app_js",
                  'The ' + fieldObj.field_title + ' contains cyclic link in the Selected Fields set.' +
                  'Please, remove ' + fieldObj2.field_title + '. from Selected Fields'
                );
                return true;
              }
            });
          });
        });
    }

    if(!this.fsvc.fieldService.Validate()){
      this.dialogs.ValidationErrors(
        this.t.translate('Validation'),
        this.fsvc.fieldService.GetValidationErrors()
      );
      return
    }

    // Validate show in target branch
    if (!this.positions.ValidateShowInTargetBranch()) {
      validateSuccess = false;
      validateErrorMessage = Yii.t("app", 'At least one position should be added to show submitted forms in the target branch. Otherwise, turn off the "Show it target branch also" option.');
      this.dialogs.Alert(Yii.t("app_js", 'Error'), validateErrorMessage);
      return false;
    }

    if (validateSuccess) {
      this.fsvc.form_json.submitted = true;
      const jsonForm = this.fsvc.form_json;

      this.api.SaveForm(this.formId(), jsonForm)
        .pipe(first())
        .subscribe({
          next: (response: {data:any,status:boolean,message:string}) => {
            if (response.status == true) {
              this.toast.add({severity: 'success', summary: Yii.t('app', 'Your template has been successfully saved!')});

              this.approvers.Save()
              this.displayFieldsService.Save()
              this.positions.Save()

              //TODO: Save Schedule!!!

              this.fsvc.hybrid.Upload(jsonForm.applySpecificPdf)

            } else {
              this.dialogs.Alert("Error", response.message);
            }
          },
          error: (e:HttpErrorResponse) => {
            this.fsvc.formLoading.set(false);
            this.dialogs.Alert("Server Error", e.message);
          }
        })
    } else {
      this.dialogs.Alert(Yii.t("app_js", 'Error'), validateErrorMessage);
    }
  };

  duplicate() {
    this.dialogs.DuplicateForm();
  };

  ngOnInit() {
    this.fsvc.Init(this.formId());
    this.asvc.Init(this.formId())
    this.displayFieldsService.Init(Number(this.formId()))
    this.loadForm()
  }

  ngOnDestroy() {
  }

}
